import './MainPageVertical.css';
import { CardSequenceBackground } from '../../components/CardSequenceBackground/CardSequenceBackground';
import { useEffect, useRef, useState } from 'react';
import SpinningCard from '../../components/SpinningCard.tsx'
import Spacer from '../../../assets/iconography/spacer.svg?react';
import type { PageIdentity } from '../../../types/page-identity.ts';
import type { DeckConfig } from '../../constants/page-orientations.tsx';
import FallingCards from '../../components/FallingCards.tsx';
import { DeckSwitchButton } from '../../components/DeckSwitchButton/DeckSwitchButton.tsx';
import { useActiveDeck } from '../../context/useDeck';

interface Props {
    navigate: (base: PageIdentity, config?: Partial<DeckConfig>) => void;
    resetWorkflow: () => void;
    hasNewPractitioners: boolean;
}

export default function MainMenuVertical({ navigate, resetWorkflow, hasNewPractitioners }: Props) {
    const containerRef = useRef<HTMLDivElement>(null);
    const [containerHeight, setContainerHeight] = useState(300);

    // Header copy follows whichever deck is on the table.
    const deck = useActiveDeck();

    useEffect(() => {
        if (!containerRef.current) return;
        const observer = new ResizeObserver(entries => {
            setContainerHeight(entries[0].contentRect.height);
        });
        observer.observe(containerRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="main-page-vertical">
            <DeckSwitchButton />
            <CardSequenceBackground zIndex={0} />
            <FallingCards maxCards={7} spawnChance={0.2} spawnRate={0.5} fallDuration={4} />
            <div className="header-text-container">
                <div className="crowley-container">
                    <p className="text-crowley">{deck.header.byline}</p>
                    <div className="right-spacer" />
                </div>
                <p className="text-title">{deck.header.title}</p>
                <p className="text-slogan">{deck.header.slogan}</p>
            </div>
            <div className='spinning-card-constraint'>
                <div ref={containerRef} className="spinning-card-container">
                    <SpinningCard height={containerHeight} />
                </div>
            </div>
            <div className="footer-segment">
                <div className="nav-control-container">
                    <button className="begin-button" onClick={() => { resetWorkflow(); navigate('card-finder-introduction-part-1') }}>~ Begin ~</button>
                    <ColouredSplit colour={'red'} />
                    <button className="deck-viewer-button" onClick={() => navigate('deck-viewer')}>Deck Viewer</button>
                    <ColouredSplit colour={'blue'} />
                    <button onClick={() => navigate('card-finder-introduction-part-1')}>Find your Cards</button>
                    <ColouredSplit colour={'yellow'} />
                    <button className="live-astrology-button" onClick={() => navigate('live-astrology')}>Live Astrology</button>
                    <ColouredSplit colour={'green'} />
                    <button className={`practitioners-button${hasNewPractitioners ? ' practitioners-pulse' : ''}`} onClick={() => navigate('practitioners-list')}>Practitioners</button>
                </div>
            </div>
        </div>
    )
}

function ColouredSplit({ colour }: { colour: string }) {
    return (
        <Spacer className="coloured-split" style={{ color: colour }} />
    )
}